export const formatDate = (value?: string, showTime = false) => {
    if (!value) return "--";

    const date = new Date(value);
    if (isNaN(date.getTime())) return "--";

    return date.toLocaleString("en-US", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        ...(showTime && {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        }),
    });
};
